import React, { useEffect, useState, Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  // Defer non-critical UI (popup) until browser is idle to keep TTI low
  const [mountIdle, setMountIdle] = useState(false);
  useEffect(() => {
    const w = window as any;
    if ('requestIdleCallback' in window) {
      const id = w.requestIdleCallback(() => setMountIdle(true), {
        timeout: 4000
      });
      return () => w.cancelIdleCallback?.(id);
    }
    const t = setTimeout(() => setMountIdle(true), 3000);
    return () => clearTimeout(t);
  }, []);
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-263">
      <div data-id="element-264">
        <HeroSection data-id="element-265" />

        <Suspense fallback={null} data-id="element-266">
          <TrustBar data-id="element-267" />
          <ContrastSection data-id="element-268" />
          <ForWhomSection data-id="element-269" />
          <BenefitsSection data-id="element-270" />
          <ContentPreview data-id="element-271" />
          <BonusSection data-id="element-272" />
          <TestimonialsSection data-id="element-273" />
          <PricingSection data-id="element-274" />
        </Suspense>

        <Suspense fallback={null} data-id="element-275">
          <GuaranteeSection data-id="element-276" />
          <ExpertSection data-id="element-277" />
          <FAQSection data-id="element-278" />
          <Footer data-id="element-279" />
          <StickyCTA data-id="element-280" />
          {mountIdle && <SocialProofPopup data-id="element-281" />}
        </Suspense>
      </div>
    </main>;
}